import { EmptyContent } from "views/components/EmptyContent";

import {
	Icon,
	Label,
	LabelWrapper,
	TabsStyled,
	TimeBlockButton,
	TimeBlocksContainer,
	Wrapper,
} from "./styles";
import { LoadingOutlined } from "@ant-design/icons";

import {
	addLabels,
	addListener,
	addSelected,
	excludeUnavailables,
	formatTimeblock,
	groupBy,
	parseTimeblock,
	sortAsc,
	timeblockGroupsAdapter,
} from "lib/timeblocks";
import { filter, map, pipe, reduce, sort } from "lib/functions";
import { useTimeBlocks, useTimeBlocksV1 } from "state/reservations/hooks";
import React, { useEffect, useGlobal, useState } from "reactn";

import { BsMoon } from "react-icons/bs";
import { CgSun } from "react-icons/cg";
import { Tabs } from "antd";
import { WiSunrise } from "react-icons/wi";
import { dateToString } from "lib/date";
import { useGetForms } from "hooks/useGetForms";
import { useTranslation } from "react-i18next";

const { TabPane } = Tabs;

const iconStyle = { fontSize: 20, marginRight: 8 };

export const Step2 = ({
	onChange,
	date,
	officeSlug,
	lineSlug,
	v2,
	tz,
	timezone,
	current,
	desktop,
	office,
	line,
}) => {
	const { t } = useTranslation(["booking"]);
	const [language] = useGlobal("language");
	const [isLoading] = useGlobal("isLoading");
	const callback = (key) => {};
	const [tbsv2, loading, error] = useTimeBlocks(
		lineSlug,
		officeSlug,
		date,
		v2
	);
	const [tbsv1, loading1, error1] = useTimeBlocksV1(
		lineSlug,
		officeSlug,
		date,
		v2
	);

	const [selectedTimeBlock, setSelectedTimeBlock] = useState(null);
	const [tabActive, setTabActive] = useState(null);
	const onChangeWrapper = (onChange) => (ev) => {
		setSelectedTimeBlock(ev);
		onChange(ev);
	};

	const getForms = useGetForms({
		officeId: office && office.id,
		lineId: line && line.id,
	});

	const handleOnChangeTabs = (event) => {
		setTabActive(event);
	};

	const timeblockGroups = pipe(
		map(parseTimeblock(timezone)),
		map(addLabels),
		map(addListener(onChangeWrapper(onChange))),
		map(addSelected(selectedTimeBlock)),
		sort(sortAsc),
		map(formatTimeblock(timezone)),
		filter(excludeUnavailables),
		reduce(groupBy("label"), {}),
		timeblockGroupsAdapter
	)(v2 ? tbsv2 : tbsv1);

	useEffect(() => {
		const [item] = timeblockGroups || [];

		if (!tabActive && item && item.label) {
			setTabActive(item.label);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [timeblockGroups]);

	if (loading1 || loading || isLoading)
		return (
			<TimeBlocksContainer align="middle" gutter={8}>
				{[0].map((_) => (
					<>
						<LoadingOutlined
							style={{
								fontSize: 38,
								color: "#7E2F8A",
								width: "100%",
								marginBottom: 8,
							}}
						/>
						<div style={{ width: "100%" }}>
							<p>{t("loadingLabelOne")}</p>
							<p>{t("loadingLabelTwo")}</p>
						</div>
					</>
				))}
			</TimeBlocksContainer>
		);

	if (error && error.message)
		//return <ErrorMessage error={error} />;
		return <EmptyContent description={t("emptyContentLabel")} />;

	return (
		<Wrapper desktop={desktop}>
			<div className="current-step-label">
				{t("step")} {current + 1}
			</div>
			<div className="title-date">
				<div>
					{t("selectSchedule")}
					<strong>{` ${dateToString(
						date,
						language.selected
					)}`}</strong>
				</div>
			</div>
			<TabsStyled
				desktop={desktop}
				onChange={handleOnChangeTabs}
				activeKey={tabActive}
				defaultActiveKey={tabActive}
			>
				{timeblockGroups.map((el) => {
					const iconSrc =
						el.label === t("night") ? (
							<BsMoon style={iconStyle} />
						) : el.label === t("afternoon") ? (
							<WiSunrise
								style={{ fontSize: 26, marginRight: 8 }}
							/>
						) : (
							<CgSun style={iconStyle} />
						);

					return (
						<TabPane
							key={el.label}
							tab={
								<LabelWrapper>
									{iconSrc}
									<Label>{el.label}</Label>
								</LabelWrapper>
							}
						>
							{el.timeblocks.map((tb, i) => {
								return (
									<TimeBlockButton onClick={tb.onClick}>
										{tb.from}
									</TimeBlockButton>
								);
							})}
						</TabPane>
					);
				})}
			</TabsStyled>

			{!loading && timeblockGroups.length === 0 && (
				<EmptyContent description={t("emptyContentLabel")} />
			)}
		</Wrapper>
	);
};
